import ActivityFeed from "./activity-feed";
import Alert from "../components/alert";
import { alertHide } from "../actions/alert";
import AnonymousNav from "../components/anonymous-nav";
import { connect } from "react-redux";
import DepositAmount from "./deposit/amount";
import DepositAddress from "./deposit/address";
import DepositConfirmation from "./deposit/confirmation";
import DepositMethod from "./deposit/method";
import DepositScreened from "./deposit/screened";
import Error404 from "./error-404";
import Favicon from "../components/favicon";
import Footer from "../components/footer";
import { getAlert, getCommunications, getSession, getUsers } from "../selectors";
import GroupBettingPools from "./group-betting-pools";
import If from "../components/if";
import LandingPage from "./landing-page";
import LoadableMyAccount from "../components/loadable-my-account";
import LoadableMyGames from "../components/loadable-my-games";
import LoadablePrivacyPolicy from "../components/loadable-privacy-policy";
import LoginLightBox from "../components/login-light-box";
import MonthlyLeaderboard from "../containers/monthly-leaderboard";
import { pageTransitioning, sessionShowLogin, sessionHideLogin, sessionLogin, sessionLogout } from "../actions/session";
import PasswordReset from "./password-reset";
import PasswordResetConfirmation from "./password-reset-confirmation";
import pure from "../components/higher-order/pure";
import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import SignUp from "./sign-up";
import SubNav from "../components/sub-nav";
import TermsAndConditions from "./terms-and-conditions";
import { trackPageView } from "../analytics";
import UserNav from "../components/user-nav";
import Welcome from "./welcome";
import WithdrawAmount from "./withdraw/amount";
import WithdrawConfirmation from "./withdraw/confirmation";
import WithdrawMethod from "./withdraw/method";
import WithdrawW9 from "./withdraw/w-9";

var favicon = "";
import(/* webpackMode: "lazy-once" */`../../public/images/favicons/${window.env.whiteLabelSite}.ico`).then(faviconModule => {
  favicon = faviconModule.default;
});

var cautionFavicon = "";
import(/* webpackMode: "lazy-once" */`../../embed/favicons/${window.env.whiteLabelSite}-caution.ico`).then(faviconModule => {
  cautionFavicon = faviconModule.default;
});

class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
    this.setExpanded = this.setExpanded.bind(this);

    var { history } = props;
    this.unlisten = history.listen((location, action) => { // eslint-disable-line no-unused-vars
      trackPageView(location.pathname);
    });
  }

  componentDidUpdate({ location: prevLocation }) {
    var { location, pageTransitioning: onPageTransitioning } = this.props;
    var prevPath = prevLocation.pathname;
    var path = location.pathname;
    if (prevPath !== path) {
      onPageTransitioning();
      this.setExpanded(false);
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  setExpanded(expanded) {
    this.setState({ expanded }); // eslint-disable-line react/no-set-state
  }

  render() {
    var {
      alert,
      alertHide: onAlertHide,
      communications,
      session,
      sessionHideLogin: onSessionHideLogin,
      sessionLogin: onSessionLogin,
      sessionLogout: onSessionLogout,
      sessionShowLogin: onSessionShowLogin,
      users
    } = this.props;
    var { expanded } = this.state;

    var connectionAlert = (<Favicon href={favicon} />);

    var connectionState = communications.getIn(["sessionConnect", "state"]);
    if (connectionState && connectionState !== "success") {
      connectionAlert = (
        <Favicon href={cautionFavicon}>
          <Alert fixed icon="dw-warning6" title="Reconnecting..." type="notification--caution">
            <p>
              The Derby Wars service appears to be unavailable. This may be due to your Internet connection. We will attempt to reconnect automatically.
            </p>
          </Alert>
        </Favicon>
      );
    }

    var className = [];
    var alertBox;
    if (alert.get("title")) {
      className.push("notification--is-present");
      alertBox = (
        <Alert fixed icon={alert.get("icon")} onDismiss={onAlertHide} title={alert.get("title")} type={alert.get("type")}>
          <p>
            {alert.get("text")}
          </p>
        </Alert>
      );
    }

    return (
      <div className={className}>
        <Nav expanded={expanded} session={session} sessionLogout={onSessionLogout} sessionShowLogin={onSessionShowLogin} setExpanded={this.setExpanded} users={users} />

        {connectionAlert}

        {alertBox}

        <Switch>
          <Route component={LandingPage} exact path="/" />

          <Route component={ActivityFeed} exact path="/tournaments" />

          <Route component={ActivityFeed} path="/tournaments/:id" />

          <Route component={MonthlyLeaderboard} path="/monthly-leaderboard" />

          <Route component={GroupBettingPools} path="/player-pool-tickets" />

          <Route component={PasswordReset} exact path="/password-reset" />

          <Route component={PasswordResetConfirmation} path="/password-reset/:token" />

          <Route component={LoadablePrivacyPolicy} path="/privacy-policy" />

          <Route component={SignUp} path="/sign-up" />

          <Route component={TermsAndConditions} path="/terms-and-conditions" />

          <Route component={Welcome} path="/welcome" />

          <Route component={LoadableMyAccount} path="/my-account" />

          <Route
            exact
            path="/my-games"
            render={() => (
              <Redirect to="/my-games/games-today" />
            )} />

          <Route component={LoadableMyGames} path="/my-games/:list/:page" />

          <Route component={LoadableMyGames} path="/my-games/:list" />

          <Route component={DepositAmount} exact path="/deposit" />

          <Route component={DepositAddress} path="/deposit/address" />

          <Route component={DepositConfirmation} path="/deposit/confirmation" />

          <Route component={DepositScreened} path="/deposit/screened" />

          <Route component={DepositMethod} path="/deposit/method" />

          <Route component={WithdrawAmount} exact path="/withdraw" />

          <Route component={WithdrawConfirmation} path="/withdraw/confirmation" />

          <Route component={WithdrawMethod} path="/withdraw/method" />

          <Route component={WithdrawW9} path="/withdraw/w-9" />

          <Route component={Error404} />
        </Switch>

        <Footer />

        <If condition={session.get("showLogin")}>
          <LoginLightBox errorMessage={communications.getIn(["sessionLogin", "error", "error"])} loading={communications.getIn(["sessionLogin", "state"]) === "in progress"} onClose={onSessionHideLogin} onLogin={onSessionLogin} />
        </If>
      </div>
    );
  }
}

var Nav = pure(function Nav(props) {
  var {
    expanded,
    session,
    sessionLogout: onSessionLogout,
    sessionShowLogin: onSessionShowLogin,
    setExpanded,
    users
  } = props;

  var nav = <AnonymousNav sessionShowLogin={onSessionShowLogin} />;
  if (session.get("user_name")) {
    nav = <UserNav expanded={expanded} session={session} sessionLogout={onSessionLogout} setExpanded={setExpanded} users={users} />;
  }

  return (
    <div className="l-header_placeholder">
      <header className="l-header">
        {nav}

        <SubNav />
      </header>
    </div>
  );
});

function select(state) {
  return {
    alert: getAlert(state),
    communications: getCommunications(state),
    session: getSession(state),
    users: getUsers(state)
  };
}

export default withRouter(connect(select, { alertHide, pageTransitioning, sessionShowLogin, sessionHideLogin, sessionLogin, sessionLogout })(App));
